import React from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  VStack,
  Box,
  Flex,
  Text,
  Avatar,
  Badge,
} from '@chakra-ui/react';
import { MessageSquare } from 'lucide-react';
import { useNotification } from '../hooks/useNotification';

export const MessagesDrawer = ({ isOpen, onClose }) => {
  const { messages } = useNotification();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
      <DrawerOverlay backdropFilter="blur(4px)" />
      <DrawerContent _dark={{ bg: '#161F30' }}>
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px">
          <Flex align="center" gap={2}>
            <MessageSquare size={18} color="#6C63FF" />
            <Text fontWeight="800" fontSize="md">Internal Team Messages</Text>
          </Flex>
        </DrawerHeader>
        <DrawerBody p={4}>
          <VStack spacing={3} align="stretch">
            {messages.map((m) => (
              <Box
                key={m.id}
                p={3.5}
                borderRadius="14px"
                bg={m.unread ? 'purple.50' : 'gray.50'}
                _dark={{ bg: m.unread ? 'rgba(108,99,255,0.1)' : 'rgba(255,255,255,0.03)' }}
                border="1px solid"
                borderColor={m.unread ? 'purple.200' : 'gray.100'}
                _dark={{ borderColor: m.unread ? 'purple.900' : 'gray.800' }}
              >
                <Flex align="start" gap={3}>
                  <Avatar size="sm" name={m.sender} />
                  <Box flex="1">
                    <Flex justify="space-between" align="center">
                      <Text fontSize="xs" fontWeight="bold">
                        {m.sender}
                      </Text>
                      <Text fontSize="10px" color="gray.400">
                        {m.time}
                      </Text>
                    </Flex>
                    <Text fontSize="xs" color="gray.600" _dark={{ color: 'gray.300' }} mt={1}>
                      {m.text}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            ))}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
